import { useAppDrawerStore } from '@/Atomic/Templates/PushDrawer'
import { LogTimeDrawer } from '@/Widgets/LogTimeDrawerWidget/LogTimeDrawer'

export interface PreFillData {
  customer?: string
  order?: string
  workPackage?: string
  date?: string
  description?: string
  productType?: string
}

export interface UseLogTimeDrawerReturn {
  open: (existingRecordId?: string, preFill?: PreFillData) => void
}

export const useLogTimeDrawer = (
  currentUserId: string,
  isLeader: boolean = false,
): UseLogTimeDrawerReturn => {
  const open = (existingRecordId?: string, preFill?: PreFillData) => {
    useAppDrawerStore
      .getState()
      .open('logTime', (onClose) => (
        <LogTimeDrawer
          close={onClose}
          recordId={existingRecordId || null}
          preFillData={preFill || null}
          currentUserId={currentUserId}
          isLeader={isLeader}
        />
      ))
  }

  return { open }
}
